import React, { useState, useEffect } from "react";
import { IMAGES } from "../constants/theme";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import { Autoplay } from "swiper";
import apiClient from "../api/apiClient";
import { useLanguage } from "../i18n/LanguageContext";

const bgImages = [IMAGES.overlayBoxpic1, IMAGES.overlayBoxpic2, IMAGES.overlayBoxpic3];

/*
 * The homepage FAQ carousel. It lists exactly the active FAQs from the admin
 * panel, and renders nothing while there are none.
 */
const GymFAQ = () => {
  const { t, language } = useLanguage();
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    let cancelled = false;

    apiClient.get("/homepage/faqs")
      .then(({ data }) => { if (!cancelled) setFaqs(Array.isArray(data) ? data : []); })
      .catch(() => { if (!cancelled) setFaqs([]); });

    return () => { cancelled = true; };
  }, [language]);

  if (faqs.length === 0) return null;

  return (
    <div className="container">
      <div className="section-head style-1 text-center">
        <h2 className="title">
          {t("Gym FAQs")}
        </h2>
      </div>
      <div className="swiper blog-slider-2">
        <Swiper
          className="swiper-wrapper"
          slidesPerView={3}
          speed={1800}
          spaceBetween={30}
          modules={[Autoplay]}
          autoplay={{ delay: 1800 }}
          breakpoints={{
            1275: { slidesPerView: 3 },
            991:  { slidesPerView: 2 },
            240:  { slidesPerView: 1 },
          }}
        >
          {faqs.map((item, ind) => (
            <SwiperSlide className="swiper-slide" key={item.id || ind}>
              <div
                className="dz-card style-2 wow fadeInUp"
                style={{ backgroundImage: `url(${bgImages[ind % bgImages.length]})` }}
              >
                <div className="post-date">
                  <span className="date">{item.tag}</span>
                  <span className="months">{item.level}</span>
                </div>

                <div className="dz-info">
                  <div className="dz-meta">
                    <ul>
                      {/* No avatar: the bundled image is a grey 50x50
                          placeholder with its own dimensions printed on it. */}
                      <li className="post-author">
                        <span>{t("Coach Answered")}</span>
                      </li>
                      <li className="post-comments">
                        <span>{t("FAQ")}</span>
                      </li>
                    </ul>
                  </div>

                  <h4 className="dz-title">
                    <Link to={`/faq#faq-${item.id}`}>{item.question}</Link>
                  </h4>

                  <p>{item.answer}</p>

                  <Link to={`/faq#faq-${item.id}`} className="btn rounded-0 btn-primary btn-skew">
                    <span>{t("View Answer")}</span>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="text-center m-t20">
        <Link to="/faq" className="btn btn-secondary btn-skew">
          <span>{t("View All FAQs")}</span>
        </Link>
      </div>
    </div>
  );
};

export default GymFAQ;
